import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { XCircle, ArrowRight, RefreshCw } from 'lucide-react';

const PaymentFailed = () => {
  const [searchParams] = useSearchParams();
  const mpReference = searchParams.get('mp_reference');
  const navigate = useNavigate();

  return (
    <div className="min-h-screen dark" style={{ background: 'linear-gradient(135deg, #080c2d 0%, #1a1a3e 100%)' }} data-testid="payment-failed-page">
      <div className="container mx-auto px-6 py-16 flex items-center justify-center min-h-screen">
        <Card className="card-viubux-dark border-red-500/20 max-w-md w-full" data-testid="payment-failed-card">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <XCircle className="w-16 h-16 text-red-500" />
            </div>
            <CardTitle className="gotham-bold text-2xl text-white">Pago No Completado</CardTitle>
            <CardDescription className="verdana-regular text-white/70">
              Tu pago no pudo ser procesado. Por favor intenta nuevamente o usa otro método de pago.
            </CardDescription>
          </CardHeader>

          <CardContent className="space-y-4">
            <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-4">
              <p className="text-red-400 text-sm text-center">
                Si el problema persiste, contacta a soporte en <strong>pagos@viubux.com</strong>
              </p>
              {mpReference && (
                <p className="text-white/50 text-xs text-center mt-2">
                  Referencia: {mpReference}
                </p>
              )}
            </div>

            <Button
              data-testid="retry-payment-btn"
              onClick={() => navigate('/dashboard')}
              className="w-full btn-viubux flex items-center justify-center gap-2"
            >
              <RefreshCw className="w-4 h-4" />
              Intentar de Nuevo
            </Button>

            <Button
              data-testid="go-to-dashboard-btn"
              onClick={() => navigate('/dashboard')}
              variant="outline"
              className="w-full border-purple-500/50 text-white hover:bg-purple-500/20 flex items-center justify-center gap-2"
            >
              Ir al Dashboard
              <ArrowRight className="w-4 h-4" />
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentFailed;
